document.addEventListener('DOMContentLoaded', () => {
    const warrantyForm = document.getElementById('warranty-form');
    if (!warrantyForm) return;

    let currentStep = 1;
    const totalSteps = 3;
    const formSteps = document.querySelectorAll('.form-step');
    const stepIndicators = document.querySelectorAll('.step-indicator');
    const submitButtons = document.querySelectorAll('#form-submit-btn');
    const backButtons = document.querySelectorAll('#form-back-btn');

    const purchaseSource = document.getElementById('purchase-source');
    const orderNumberInput = document.getElementById('order-number');
    const fetchOrderBtn = document.getElementById('fetch-order-btn');
    const fetchOrderSection = document.getElementById('fetch-order-section');
    const productTypeField = document.getElementById('product-type');
    const productNameField = document.getElementById('product-name');
    const variantNameField = document.getElementById('variant-name');
    const productColorField = document.getElementById('product-color');
    const skuField = document.getElementById('sku');
    const issueVideoInput = document.getElementById('issue-video');
    const videoUrlContainer = document.getElementById('video-url-container');
    const videoUrlInput = document.getElementById('video-url');
    const customPopup = document.getElementById('custom-popup');
    const popupOk = document.getElementById('popup-ok');
    const popupCancel = document.getElementById('popup-cancel');
    const overlay = document.getElementById('form-overlay');
    const overlayCloseBtn = document.getElementById('overlay-close-btn');
    const overlayContent = document.getElementById('overlay-content');
    const overlayMessage = document.getElementById('overlay-message');
    const submitBtnText = document.getElementById('submit-btn-text');
    const submitBtnSpinner = document.getElementById('submit-btn-spinner');

    let allProducts = [];
    const PRODUCT_TYPES_FALLBACK = [
        'Travel Accessories',
        'Briefcases & Duffles',
        'Backpacks',
        'Luggage',
        'Totes & Handbags',
        'Kids Luggage',
        'Kids Backpacks',
        'Rain Umbrellas',
        'Luggage Covers'
    ];
    let productNamesFetchedFromOrders = false;
    let orderProducts = [];
    let websiteSelected = false;

    const customerOrders = window.warrantyFormData ? window.warrantyFormData.customerOrders : [];
    const isUserLoggedIn = customerOrders.length > 0;

    populateProductFields();
    setupStoreDropdown();
    setupEventListeners();
    updateStepDisplay();

    function updateStepDisplay() {
        formSteps.forEach((step, index) => {
            if (index + 1 === currentStep) {
                step.classList.remove('hidden');
            } else {
                step.classList.add('hidden');
            }
        });

        stepIndicators.forEach((indicator, index) => {
            if (index + 1 === currentStep) {
                indicator.classList.add('text-black', 'font-medium');
                indicator.classList.remove('text-[#A6A6A6]', 'font-normal');
            } else if (index + 1 < currentStep) {
                indicator.classList.remove('text-[#A6A6A6]', 'font-normal');
                indicator.classList.add('text-black', 'font-medium');
            } else {
                indicator.classList.remove('text-black', 'font-medium');
                indicator.classList.add('text-[#A6A6A6]', 'font-normal');
            }
        });

        submitButtons.forEach(btn => {
            const textSpan = btn.querySelector('#submit-btn-text');
            if (textSpan) {
                if (currentStep === totalSteps) {
                    textSpan.textContent = 'SUBMIT';
                    btn.type = 'submit';
                } else {
                    textSpan.textContent = 'SAVE & CONTINUE';
                    btn.type = 'button';
                }
            }
        });

        updateBackButtonVisibility();
    }

    function goToNextStep() {
        if (currentStep >= totalSteps) return;
        currentStep++;
        updateStepDisplay();
    }

    function goToPreviousStep() {
        if (currentStep > 1) {
            currentStep--;
            updateStepDisplay();
        }
    }

    function updateBackButtonVisibility() {
        backButtons.forEach(btn => {
            if (currentStep === 1) {
                btn.classList.add('hidden');
            } else {
                btn.classList.remove('hidden');
            }
        });
    }

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function validatePhone(phone) {
        return /^\d{10}$/.test(phone);
    }

    function validatePincode(pincode) {
        return /^\d{6}$/.test(pincode);
    }

    function showError(fieldId, errorMessage) {
        const errorSpan = document.getElementById(`${fieldId}-error`);
        if (errorSpan) {
            errorSpan.textContent = errorMessage;
        }
    }

    function clearError(fieldId) {
        const errorSpan = document.getElementById(`${fieldId}-error`);
        if (errorSpan) {
            errorSpan.textContent = '';
        }
    }

    function clearAllErrors() {
        const errorFields = [
            'purchase-source', 'bought-store', 'order-number', 'full-name', 'email', 'phone',
            'address', 'pincode', 'city', 'state', 'product-type', 'product-name',
            'variant-name', 'product-size', 'purchase-date', 'invoice-id', 'invoice',
            'issue-details', 'issue-images', 'issue-video'
        ];
        errorFields.forEach(fieldId => clearError(fieldId));
    }

    function scrollToAndFocusField(fieldId) {
        const field = document.getElementById(fieldId);
        if (!field) return;

        const step = field.closest('.form-step');
        if (step?.classList.contains('hidden')) {
            step.classList.remove('hidden');
            const stepNumber = step.dataset.step;
            if (stepNumber) {
                currentStep = parseInt(stepNumber, 10);
                updateStepDisplay();
            }
        }

        field.scrollIntoView({ behavior: 'smooth', block: 'center' });

        setTimeout(() => {
            field.focus();
            if (field.tagName === 'SELECT') {
                field.click();
            }
        }, 300);
    }

    function validateStep1() {
        let isValid = true;
        let firstInvalidField = null;
        clearAllErrors();

        if (!purchaseSource || !purchaseSource.value) {
            showError('purchase-source', 'Please select your source of purchase');
            if (!firstInvalidField) firstInvalidField = 'purchase-source';
            isValid = false;
        }

        if (purchaseSource && purchaseSource.value === 'Mokobara Retail Store') {
            const boughtStoreEl = document.getElementById('bought-store');
            const storeCode = boughtStoreEl ? boughtStoreEl.value : '';
            if (!storeCode) {
                showError('bought-store', 'Please select a store');
                if (!firstInvalidField) firstInvalidField = 'bought-store';
                isValid = false;
            }
        }

        const fullName = document.getElementById('full-name').value.trim();
        if (!fullName) {
            showError('full-name', 'Please enter your full name.');
            if (!firstInvalidField) firstInvalidField = 'full-name';
            isValid = false;
        } else if (!/^[A-Za-z\s]{2,}$/.test(fullName)) {
            showError('full-name', 'Name must be at least 2 alphabetic characters.');
            if (!firstInvalidField) firstInvalidField = 'full-name';
            isValid = false;
        }

        const email = document.getElementById('email').value.trim();
        if (!email) {
            showError('email', 'Please enter your email.');
            if (!firstInvalidField) firstInvalidField = 'email';
            isValid = false;
        } else if (!validateEmail(email)) {
            showError('email', 'Please enter a valid email address.');
            if (!firstInvalidField) firstInvalidField = 'email';
            isValid = false;
        }

        const phone = document.getElementById('phone').value.trim();
        if (!phone) {
            showError('phone', 'Please enter your phone number.');
            if (!firstInvalidField) firstInvalidField = 'phone';
            isValid = false;
        } else if (!validatePhone(phone)) {
            showError('phone', 'Phone number must be exactly 10 digits.');
            if (!firstInvalidField) firstInvalidField = 'phone';
            isValid = false;
        }

        const address = document.getElementById('address').value.trim();
        if (!address) {
            showError('address', 'Please enter your address.');
            if (!firstInvalidField) firstInvalidField = 'address';
            isValid = false;
        }

        const pincode = document.getElementById('pincode').value.trim();
        if (!pincode) {
            showError('pincode', 'Please enter your pincode.');
            if (!firstInvalidField) firstInvalidField = 'pincode';
            isValid = false;
        } else if (!validatePincode(pincode)) {
            showError('pincode', 'Pincode must be exactly 6 digits.');
            if (!firstInvalidField) firstInvalidField = 'pincode';
            isValid = false;
        }

        const city = document.getElementById('city').value.trim();
        if (!city) {
            showError('city', 'Please enter your city.');
            if (!firstInvalidField) firstInvalidField = 'city';
            isValid = false;
        }

        const state = document.getElementById('state')?.value.trim() || '';
        if (!state) {
            showError('state', 'Please enter your state.');
            if (!firstInvalidField) firstInvalidField = 'state';
            isValid = false;
        }

        if (!isValid && firstInvalidField) {
            scrollToAndFocusField(firstInvalidField);
        }

        return isValid;
    }

    function validateStep2() {
        let isValid = true;
        let firstInvalidField = null;
        clearAllErrors();

        const productType = productTypeField.value;
        if (!productType) {
            showError('product-type', 'Please select a product type.');
            if (!firstInvalidField) firstInvalidField = 'product-type';
            isValid = false;
        }

        const productName = productNameField.value;
        if (!productName) {
            showError('product-name', 'Please select a product.');
            if (!firstInvalidField) firstInvalidField = 'product-name';
            isValid = false;
        }

        const variantName = variantNameField.value;
        if (!variantName) {
            showError('variant-name', 'Please select a variant.');
            if (!firstInvalidField) firstInvalidField = 'variant-name';
            isValid = false;
        }

        const productSize = document.getElementById('product-size')?.value || '';
        const luggageTypes = ['Luggage', 'Kids Luggage'];
        if (luggageTypes.includes(productType) && !productSize) {
            showError('product-size', 'Please select the product size for luggage.');
            if (!firstInvalidField) firstInvalidField = 'product-size';
            isValid = false;
        }

        const purchaseDate = document.getElementById('purchase-date').value;
        if (!purchaseDate) {
            showError('purchase-date', 'Please enter the purchase date.');
            if (!firstInvalidField) firstInvalidField = 'purchase-date';
            isValid = false;
        } else if (new Date(purchaseDate) > new Date()) {
            showError('purchase-date', 'Purchase date cannot be in the future.');
            if (!firstInvalidField) firstInvalidField = 'purchase-date';
            isValid = false;
        }

        const invoice = document.getElementById('invoice').files[0];
        if (!invoice) {
            showError('invoice', 'Please upload your invoice.');
            if (!firstInvalidField) firstInvalidField = 'invoice';
            isValid = false;
        } else {
            if (invoice.size > 20 * 1024 * 1024) {
                showError('invoice', 'Invoice file must be under 20MB.');
                if (!firstInvalidField) firstInvalidField = 'invoice';
                isValid = false;
            } else if (!/\.(pdf|jpg|jpeg|png)$/i.test(invoice.name)) {
                showError('invoice', 'Invoice must be PDF, JPG, JPEG, or PNG format.');
                if (!firstInvalidField) firstInvalidField = 'invoice';
                isValid = false;
            }
        }

        const invoiceId = document.getElementById('invoice-id').value.trim();
        if (!invoiceId) {
            showError('invoice-id', 'Please enter your Order ID.');
            if (!firstInvalidField) firstInvalidField = 'invoice-id';
            isValid = false;
        }

        const issueDetails = document.getElementById('issue-details').value.trim();
        if (!issueDetails) {
            showError('issue-details', 'Please describe the issue you are facing.');
            if (!firstInvalidField) firstInvalidField = 'issue-details';
            isValid = false;
        }

        const issueImages = document.getElementById('issue-images').files;
        if (!issueImages || issueImages.length < 1 || issueImages.length > 5) {
            showError('issue-images', 'Please select between 1 and 5 images.');
            if (!firstInvalidField) firstInvalidField = 'issue-images';
            isValid = false;
        } else if (!Array.from(issueImages).every((f) => /\.(jpg|jpeg|png)$/i.test(f.name))) {
            showError('issue-images', 'Images must be JPG, JPEG, or PNG format.');
            if (!firstInvalidField) firstInvalidField = 'issue-images';
            isValid = false;
        } else {
            const totalSize = Array.from(issueImages).reduce((sum, file) => sum + file.size, 0);
            if (totalSize > 20 * 1024 * 1024) {
                showError('issue-images', 'Total image size must not exceed 20MB.');
                if (!firstInvalidField) firstInvalidField = 'issue-images';
                isValid = false;
            }
        }

        const issueVideo = document.getElementById('issue-video').files[0];
        const videoUrlValue = document.getElementById('video-url')?.value.trim() || '';
        if (!issueVideo && !videoUrlValue) {
            showError('issue-video', 'Please upload a product video.');
            if (!firstInvalidField) firstInvalidField = 'issue-video';
            isValid = false;
        } else if (issueVideo) {
            if (!/\.(mp4|mov|avi|mkv|webm|wmv|m4v)$/i.test(issueVideo.name)) {
                showError('issue-video', 'Video must be MP4, MOV, AVI, MKV, WEBM, WMV, or M4V format.');
                if (!firstInvalidField) firstInvalidField = 'issue-video';
                isValid = false;
            } else if (issueVideo.size > 50 * 1024 * 1024) {
                showError('issue-video', 'Video file must be under 50MB.');
                if (!firstInvalidField) firstInvalidField = 'issue-video';
                isValid = false;
            }
        }

        if (!isValid && firstInvalidField) {
            scrollToAndFocusField(firstInvalidField);
        }

        return isValid;
    }

    function setupInputValidation() {
        const fields = [
            { id: 'purchase-source', type: 'select' },
            { id: 'bought-store', type: 'select' },
            { id: 'order-number', type: 'input' },
            { id: 'full-name', type: 'input' },
            { id: 'email', type: 'input' },
            { id: 'phone', type: 'input' },
            { id: 'address', type: 'textarea' },
            { id: 'pincode', type: 'input' },
            { id: 'city', type: 'textarea' },
            { id: 'state', type: 'input' },
            { id: 'product-type', type: 'select' },
            { id: 'product-name', type: 'select' },
            { id: 'variant-name', type: 'select' },
            { id: 'product-size', type: 'select' },
            { id: 'purchase-date', type: 'input' },
            { id: 'invoice-id', type: 'input' },
            { id: 'invoice', type: 'file' },
            { id: 'issue-details', type: 'textarea' },
            { id: 'issue-images', type: 'file' },
            { id: 'issue-video', type: 'file' }
        ];

        fields.forEach(field => {
            const element = document.getElementById(field.id);
            if (element) {
                if (field.type === 'select') {
                    element.addEventListener('change', () => clearError(field.id));
                } else if (field.type === 'file') {
                    element.addEventListener('change', () => clearError(field.id));
                } else {
                    element.addEventListener('input', () => clearError(field.id));
                }
            }
        });
    }

    function setupInputRestrictions() {
        const phoneInput = document.getElementById('phone');
        if (phoneInput) {
            phoneInput.addEventListener('input', function (e) {
                this.value = this.value.replace(/[^0-9]/g, '');
                if (this.value.length > 15) {
                    this.value = this.value.slice(0, 15);
                }
            });
        }

        const pincodeInput = document.getElementById('pincode');
        const cityInput = document.getElementById('city');
        const stateInput = document.getElementById('state');
        if (pincodeInput) {
            pincodeInput.addEventListener('input', function (e) {
                this.value = this.value.replace(/[^0-9]/g, '');
                if (this.value.length > 6) {
                    this.value = this.value.slice(0, 6);
                }
                if (this.value.length === 6) {
                    getCityState(this.value);
                } else {
                    if (cityInput) cityInput.value = '';
                    if (stateInput) stateInput.value = '';
                }
            });

            pincodeInput.addEventListener('wheel', function (event) {
                event.preventDefault();
            });
        }
    }

    function getCityState(pincode) {
        const cityInput = document.getElementById('city');
        const stateInput = document.getElementById('state');
        if (pincode.length === 6 && cityInput) {
            fetch(`https://api.postalpincode.in/pincode/${pincode}`)
                .then(response => response.json())
                .then(data => {
                    if (data[0] && data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length > 0) {
                        const postOffice = data[0].PostOffice[0];
                        cityInput.value = postOffice.District;
                        if (stateInput) stateInput.value = postOffice.State;
                        clearError('pincode');
                        clearError('city');
                        clearError('state');
                    } else {
                        showError('pincode', 'Invalid pincode');
                    }
                })
                .catch(error => {
                    console.error('Error fetching city:', error);
                });
        }
    }

    function renderProductTypes(types) {
        if (!productTypeField) return;
        productTypeField.innerHTML = '<option value="" disabled selected>Select a product type</option>';
        types.forEach(type => {
            const option = document.createElement('option');
            option.value = type;
            option.textContent = type || 'Unknown Product Type';
            productTypeField.appendChild(option);
        });
    }

    async function populateProductFields() {
        if (!productTypeField) return;
        productTypeField.innerHTML = '<option value="" disabled selected>Loading product types...</option>';

        try {
            const response = await fetch('https://themokolabs.com/api/customer/warranty/get-product-types');
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            const types = Array.isArray(data?.product_types) && data.product_types.length > 0
                ? data.product_types
                : PRODUCT_TYPES_FALLBACK;
            renderProductTypes(types);
        } catch (error) {
            console.error('Error fetching product types:', error);
            renderProductTypes(PRODUCT_TYPES_FALLBACK);
        }
    }

    function setupStoreDropdown() {
        // Store dropdown visibility is now driven by handlePurchaseSourceChange
        // which toggles #bought-store-wrapper. fetchStoreCodes() runs on demand.
    }

    async function fetchStoreCodes() {
        const boughtStore = document.getElementById('bought-store');
        if (!boughtStore) return;

        boughtStore.innerHTML = '<option value="" disabled selected>Select a Store</option>';

        try {
            const response = await fetch('https://themokolabs.com/api/customer/get-store-codes-and-names');
            const data = await response.json();

            if (data.stores && data.stores.length > 0) {
                data.stores.forEach(store => {
                    const option = document.createElement('option');
                    option.value = store.store_code;
                    option.textContent = store.store_name;
                    boughtStore.appendChild(option);
                });
            }
        } catch (error) {
            console.error('Error fetching store codes:', error);
        }
    }

    function updateProductNames() {
        const selectedType = productTypeField.value;
        if (!productNameField) return;

        productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';
        productNameField.disabled = !selectedType;
        updateFieldDisabledState(productNameField, !selectedType);

        if (!selectedType) {
            variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
            variantNameField.disabled = true;
            updateFieldDisabledState(variantNameField, true);
            return;
        }

        if (productNamesFetchedFromOrders) {
            const matchingProducts = [];
            const uniqueProductIds = new Set();

            orderProducts.forEach(product => {
                const typeMatches = product.product_type === selectedType;
                const productKey = `${product.product_title}_${product.product_id}`;

                if (typeMatches && !uniqueProductIds.has(productKey)) {
                    uniqueProductIds.add(productKey);
                    const option = document.createElement('option');
                    option.value = product.product_title;
                    option.textContent = product.product_title;
                    productNameField.appendChild(option);
                    matchingProducts.push(product.product_title);
                }
            });

            if (matchingProducts.length === 1) {
                productNameField.value = matchingProducts[0];
                productNameField.dispatchEvent(new Event('change'));
            }
            return;
        }

        productNameField.innerHTML = '<option value="" disabled selected>Loading products...</option>';

        const encodedType = encodeURIComponent(selectedType);
        fetch(`https://themokolabs.com/api/customer/warranty/get-product-names?type=${encodedType}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.product_names && data.product_names.length > 0) {
                    productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';

                    data.product_names.forEach((productName) => {
                        const option = document.createElement('option');
                        option.value = productName;
                        option.textContent = productName;
                        productNameField.appendChild(option);
                    });
                } else {
                    productNameField.innerHTML = '<option value="" disabled selected>No products available for this type</option>';
                }
            })
            .catch((error) => {
                console.error("Error fetching product names:", error);
                productNameField.innerHTML = '<option value="" disabled selected>Error loading products</option>';
            });
    }

    function updateVariantDetails() {
        const selectedType = productTypeField.value;
        const selectedName = productNameField.value;

        if (!variantNameField) return;

        if (!selectedType || !selectedName) {
            variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
            variantNameField.disabled = true;
            updateFieldDisabledState(variantNameField, true);
            skuField.value = '';
            productColorField.value = '';
            return;
        }

        variantNameField.disabled = false;
        updateFieldDisabledState(variantNameField, false);
        variantNameField.innerHTML = '<option value="" disabled selected>Loading variants...</option>';
        skuField.value = '';
        productColorField.value = '';

        const encodedType = encodeURIComponent(selectedType);
        const encodedName = encodeURIComponent(selectedName);

        fetch(`https://themokolabs.com/api/customer/warranty/get-product-variants?type=${encodedType}&name=${encodedName}`)
            .then(response => response.json())
            .then(data => {
                variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';

                if (data.variants && Array.isArray(data.variants) && data.variants.length > 0) {
                    data.variants.forEach(variant => {
                        const option = document.createElement('option');
                        option.value = variant;
                        option.textContent = variant;
                        variantNameField.appendChild(option);
                    });

                    if (data.variants.length === 1) {
                        variantNameField.value = data.variants[0];
                        variantNameField.dispatchEvent(new Event('change'));
                    }
                } else {
                    console.error('Error in variant API response:', data.message || 'No variants found');
                    variantNameField.innerHTML = '<option value="" disabled selected>No variants available</option>';
                }
            })
            .catch(error => {
                console.error('Error fetching variant data:', error);
                variantNameField.innerHTML = '<option value="" disabled selected>Error loading variants</option>';
            });
    }

    // Order Fetching
    function fetchOrderDetails() {
        const orderId = orderNumberInput.value.trim();

        if (!orderId) {
            showOverlay('error', 'Please enter order ID');
            return;
        }

        if (!isUserLoggedIn) {
            showOverlay('error', 'Please <a href="/account/login" style="color: #007BFF; text-decoration: underline;">log in</a> to fetch order details automatically, or continue filling the form manually.');
            return;
        }

        const foundOrder = customerOrders.find(order => {
            return order.name === orderId ||
                order.name === '#' + orderId ||
                order.order_number.toString() === orderId ||
                order.id.toString() === orderId;
        });

        if (!foundOrder) {
            showOverlay('error', 'Order not found in your account');
            clearOrderFields();
            return;
        }

        if (foundOrder.financial_status === 'cancelled') {
            showOverlay('error', 'Order has been cancelled. Warranty claims are not available for cancelled orders.');
            return;
        }

        const canProceed = foundOrder.fulfillment_status === 'fulfilled' || foundOrder.fulfillment_status === 'partial';
        if (!canProceed) {
            let statusMessage = 'Order is not fulfilled yet. Please wait for fulfillment to claim warranty.';
            if (foundOrder.fulfillment_status) {
                statusMessage = `Order status: ${foundOrder.fulfillment_status.charAt(0).toUpperCase() + foundOrder.fulfillment_status.slice(1)}. Please wait for fulfillment to claim warranty.`;
            }
            showOverlay('error', statusMessage);
            return;
        }

        fillFormFromOrder(foundOrder);
        showOverlay('success', 'Found your order details!');
    }

    function fillFormFromOrder(order) {
        const shippingAddr = order.shipping_address;
        document.getElementById('full-name').value = `${shippingAddr.first_name || ''} ${shippingAddr.last_name || ''}`.trim();
        document.getElementById('email').value = order.customer.email || '';
        document.getElementById('phone').value = shippingAddr.phone || '';

        const addressParts = [shippingAddr.address1, shippingAddr.address2].filter(part => part && part.trim() !== '');
        document.getElementById('address').value = addressParts.join(', ');
        document.getElementById('pincode').value = shippingAddr.zip || '';
        const cityInput = document.getElementById('city');
        const stateInput = document.getElementById('state');
        if (shippingAddr.zip && shippingAddr.zip.length === 6) {
            getCityState(shippingAddr.zip);
        } else {
            if (cityInput) cityInput.value = shippingAddr.city || '';
            if (stateInput) stateInput.value = shippingAddr.province || '';
        }

        const purchaseDateField = document.getElementById('purchase-date');
        if (purchaseDateField && order.created_at && order.created_at.match(/^\d{4}-\d{2}-\d{2}$/)) {
            purchaseDateField.value = order.created_at;
        }

        productTypeField.innerHTML = '<option value="" disabled selected>Select a product type</option>';
        productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';

        orderProducts = order.line_items;
        productNamesFetchedFromOrders = true;

        let uniqueProductTypes = [...new Set(order.line_items
            .map(item => item.product_type)
            .filter(type => type && type.trim() !== '')
        )];

        if (uniqueProductTypes.length === 0 && allProducts.length > 0) {
            const orderProductTitles = order.line_items.map(item => item.product_title);
            const matchingTypes = [];
            orderProductTitles.forEach(title => {
                const matchingProduct = allProducts.find(p => p.title === title);
                if (matchingProduct && matchingProduct.productType) {
                    matchingTypes.push(matchingProduct.productType);
                }
            });
            uniqueProductTypes = [...new Set(matchingTypes)];
        }

        uniqueProductTypes.forEach(productType => {
            const option = document.createElement('option');
            option.value = productType;
            option.textContent = productType;
            productTypeField.appendChild(option);
        });

        if (uniqueProductTypes.length === 1) {
            productTypeField.value = uniqueProductTypes[0];
            productTypeField.dispatchEvent(new Event('change'));
        }
    }

    function clearOrderFields() {
        document.getElementById('full-name').value = '';
        document.getElementById('email').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('address').value = '';
        document.getElementById('purchase-date').value = '';
        const cityInput = document.getElementById('city');
        if (cityInput) cityInput.value = '';
        const stateInput = document.getElementById('state');
        if (stateInput) stateInput.value = '';
        document.getElementById('pincode').value = '';
    }

    // Video Upload Handling
    function handleVideoUpload() {
        if (!issueVideoInput) return;
        issueVideoInput.addEventListener('change', function (event) {
            const file = event.target.files[0];
            const maxSize = 50 * 1024 * 1024;

            if (file) {
                if (!/\.(mp4|mov|avi|mkv|webm|wmv|m4v)$/i.test(file.name)) {
                    showError('issue-video', 'Video must be MP4, MOV, AVI, MKV, WEBM, WMV, or M4V format.');
                    event.target.value = '';
                } else if (file.size > maxSize) {
                    showError('issue-video', 'File size exceeds 50MB. Please paste the video URL instead.');
                    videoUrlContainer.classList.remove('hidden');
                    event.target.value = '';
                } else {
                    clearError('issue-video');
                    videoUrlContainer.classList.add('hidden');
                }
            } else {
                clearError('issue-video');
                videoUrlContainer.classList.add('hidden');
            }
        });

        if (videoUrlInput) {
            videoUrlInput.addEventListener('input', function () {
                if (this.value.trim() !== '') {
                    clearError('issue-video');
                }
            });
        }
    }

    // Image Upload Handling
    function handleImageUpload() {
        const issueImagesInput = document.getElementById('issue-images');
        if (!issueImagesInput) return;

        issueImagesInput.addEventListener('change', function (event) {
            const fileInput = event.target;
            const files = Array.from(fileInput.files);
            const dataTransfer = new DataTransfer();
            let validFileCount = 0;
            let totalSize = 0;
            const rejectedFiles = [];

            for (const file of files) {
                if (validFileCount >= 5) {
                    rejectedFiles.push(`${file.name} - Only the first 5 files are allowed`);
                    continue;
                }
                if (!/\.(jpg|jpeg|png)$/i.test(file.name)) {
                    rejectedFiles.push(`${file.name} - Must be JPG, JPEG, or PNG`);
                    continue;
                }
                if (file.size > 20 * 1024 * 1024) {
                    rejectedFiles.push(`${file.name} - File exceeds 20MB limit`);
                    continue;
                }
                if (totalSize + file.size > 20 * 1024 * 1024) {
                    rejectedFiles.push(`${file.name} - Total size would exceed 20MB limit`);
                    continue;
                }

                dataTransfer.items.add(file);
                validFileCount++;
                totalSize += file.size;
            }

            fileInput.files = dataTransfer.files;
            clearError('issue-images');

            if (rejectedFiles.length > 0) {
                showError('issue-images', 'Files not accepted: ' + rejectedFiles.join(', '));
            }
        });
    }

    function setupPurchaseDate() {
        const dateInput = document.getElementById('purchase-date');
        if (!dateInput) return;

        const today = new Date().toISOString().split('T')[0];
        dateInput.setAttribute('max', today);

        const dateContainer = dateInput.closest('.form-field');
        if (dateContainer) {
            dateContainer.addEventListener('click', function (e) {
                if (e.target === dateInput || e.target.closest('fieldset') === dateInput.closest('fieldset')) {
                    dateInput.showPicker();
                }
            });
        }

        dateInput.addEventListener('change', function () {
            if (new Date(dateInput.value) > new Date(today)) {
                showError('purchase-date', "Please select today's date or a past date.");
                dateInput.value = '';
            }
        });
    }

    function showOverlay(type, message) {
        if (!overlay) return;
        const successIcon = overlay.querySelector('#success-icon');
        const errorIcon = overlay.querySelector('#error-icon');
        const messageEl = overlay.querySelector('#overlay-message');

        overlay.classList.remove('hidden');
        overlay.classList.add('flex');

        if (successIcon && errorIcon) {
            if (type === 'success') {
                successIcon.classList.remove('hidden');
                errorIcon.classList.add('hidden');
            } else {
                successIcon.classList.add('hidden');
                errorIcon.classList.remove('hidden');
            }
        }

        if (messageEl) {
            messageEl.innerHTML = message;
        }
    }

    function closeOverlay() {
        if (!overlay) return;
        const successIcon = overlay.querySelector('#success-icon');
        overlay.classList.add('hidden');
        overlay.classList.remove('flex');
        enableFormFields();
        if (successIcon && !successIcon.classList.contains('hidden')) {
            warrantyForm.reset();
            currentStep = 1;
            updateStepDisplay();
        }
    }

    function disableFormFields() {
        const formElements = warrantyForm.querySelectorAll('input, select, textarea, button');
        formElements.forEach(element => {
            element.disabled = true;
        });
    }

    function updateFieldDisabledState(field, isDisabled) {
        if (!field) return;
        const fieldset = field.closest('fieldset');

        if (isDisabled) {
            field.classList.add('cursor-not-allowed', 'opacity-60');
            field.classList.remove('opacity-100');
            field.setAttribute('aria-disabled', 'true');
            if (fieldset) {
                fieldset.classList.add('bg-gray-100');
            }
        } else {
            field.classList.remove('cursor-not-allowed', 'opacity-60');
            field.classList.add('opacity-100');
            field.setAttribute('aria-disabled', 'false');
            if (fieldset) {
                fieldset.classList.remove('bg-gray-100');
            }
        }
    }

    function enableFormFields() {
        const formElements = warrantyForm.querySelectorAll('input, select, textarea, button');
        formElements.forEach(element => {
            if (element.id !== 'product-color' && element.id !== 'sku') {
                element.disabled = false;
                updateFieldDisabledState(element, false);
            }
        });
        if (productNameField && !productTypeField.value) {
            productNameField.disabled = true;
            updateFieldDisabledState(productNameField, true);
        }
        if (variantNameField && !productNameField.value) {
            variantNameField.disabled = true;
            updateFieldDisabledState(variantNameField, true);
        }
    }

    function showLoader() {
        if (submitBtnText) submitBtnText.classList.add('hidden');
        if (submitBtnSpinner) submitBtnSpinner.classList.remove('hidden');
    }

    function hideLoader() {
        if (submitBtnText) submitBtnText.classList.remove('hidden');
        if (submitBtnSpinner) submitBtnSpinner.classList.add('hidden');
    }

    async function handleFormSubmission(e) {
        e.preventDefault();

        if (currentStep < totalSteps) {
            if (currentStep === 1 && !validateStep1()) {
                return;
            }
            if (currentStep === 2 && !validateStep2()) {
                return;
            }
            goToNextStep();
            return;
        }

        if (!validateStep1() || !validateStep2()) {
            return;
        }

        showLoader();
        disableFormFields();

        // Convert date from YYYY-MM-DD to DD-MM-YYYY
        function formatDateForAPI(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }

        const formData = new FormData();
        formData.append('purchased_from_platform', purchaseSource.value);

        const boughtStore = document.getElementById('bought-store')?.value;
        if (purchaseSource.value === 'Mokobara Retail Store' && boughtStore) {
            formData.append('purchased_from_store_code', boughtStore);
        }

        formData.append('customer_name', document.getElementById('full-name').value);
        formData.append('customer_email', document.getElementById('email').value);
        formData.append('customer_phone', document.getElementById('phone').value);
        formData.append('address', document.getElementById('address').value);
        formData.append('pincode', document.getElementById('pincode').value);
        formData.append('city', document.getElementById('city').value);
        formData.append('state', document.getElementById('state')?.value || '');
        formData.append('product_type', productTypeField.value);
        formData.append('product_name', productNameField.value);
        formData.append('variant_name', variantNameField.value);
        formData.append('product_color', productColorField.value);
        formData.append('product_sku', skuField.value);

        const productSize = document.getElementById('product-size')?.value;
        if (productSize) {
            formData.append('product_size', productSize);
        }

        formData.append('purchased_date', formatDateForAPI(document.getElementById('purchase-date').value));
        formData.append('invoice_id', document.getElementById('invoice-id').value.trim());
        formData.append('issue_details', document.getElementById('issue-details').value.trim());

        const remarks = document.getElementById('remarks')?.value.trim() || '';
        if (remarks) {
            formData.append('remarks', remarks);
        }

        const invoice = document.getElementById('invoice').files[0];
        if (invoice) {
            formData.append('invoice_urls', invoice);
        }

        const issueImages = document.getElementById('issue-images').files;
        Array.from(issueImages).forEach(file => {
            formData.append('uploaded_product_image_urls', file);
        });

        if (issueVideoInput && issueVideoInput.files[0]) {
            formData.append('uploaded_product_video_urls', issueVideoInput.files[0]);
        } else if (videoUrlInput && videoUrlInput.value.trim()) {
            formData.append('uploaded_product_video_urls', videoUrlInput.value.trim());
        }

        try {
            const response = await fetch('https://themokolabs.com/api/customer/create-warranty-form-online', {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            hideLoader();
            enableFormFields();

            if (!response.ok || !result.success) {
                const errorMessage = result.error || 'An error occurred. Please try again.';
                showOverlay('error', errorMessage);
                return;
            }

            showOverlay('success', 'Thank you for submitting your warranty claim! Our team will carefully review your submission and contact you via your provided email within 24-48 hours. For further queries, please email <a href="mailto:support@mokobara.com" style="text-decoration: underline; text-underline-offset: 3px;">support@mokobara.com</a>');
            warrantyForm.reset();
            productColorField.value = '';
            skuField.value = '';
            websiteSelected = false;
            const orderNumberWrapper = document.getElementById('order-number-wrapper');
            const boughtStoreWrapper = document.getElementById('bought-store-wrapper');
            if (orderNumberWrapper) orderNumberWrapper.classList.add('hidden');
            if (boughtStoreWrapper) boughtStoreWrapper.classList.add('hidden');
            if (fetchOrderSection) fetchOrderSection.classList.add('hidden');
            if (videoUrlContainer) videoUrlContainer.classList.add('hidden');
            currentStep = 1;
            updateStepDisplay();
        } catch (error) {
            console.error('Error placing request:', error);
            hideLoader();
            enableFormFields();
            showOverlay('error', 'An error occurred. Please try again.');
        }
    }

    function handlePurchaseSourceChange() {
        if (!purchaseSource) return;
        const orderNumberWrapper = document.getElementById('order-number-wrapper');
        const boughtStoreWrapper = document.getElementById('bought-store-wrapper');

        purchaseSource.addEventListener('change', function (event) {
            const newSelection = purchaseSource.value;

            // Hide both conditional wrappers by default
            if (orderNumberWrapper) orderNumberWrapper.classList.add('hidden');
            if (boughtStoreWrapper) boughtStoreWrapper.classList.add('hidden');

            if (newSelection === 'Mokobara Website') {
                websiteSelected = true;
                if (orderNumberWrapper) orderNumberWrapper.classList.remove('hidden');
                if (fetchOrderSection) fetchOrderSection.classList.remove('hidden');
            } else if (newSelection === 'Mokobara Retail Store') {
                if (websiteSelected) {
                    event.preventDefault();
                    showCustomPopup(
                        () => {
                            localStorage.setItem('selectedPurchaseSource', newSelection);
                            location.reload();
                        },
                        () => {
                            purchaseSource.value = 'Mokobara Website';
                            if (orderNumberWrapper) orderNumberWrapper.classList.remove('hidden');
                            if (fetchOrderSection) fetchOrderSection.classList.remove('hidden');
                        }
                    );
                    return;
                }
                if (fetchOrderSection) fetchOrderSection.classList.add('hidden');
                if (boughtStoreWrapper) boughtStoreWrapper.classList.remove('hidden');
                fetchStoreCodes();
            } else {
                if (websiteSelected) {
                    event.preventDefault();
                    showCustomPopup(
                        () => {
                            localStorage.setItem('selectedPurchaseSource', newSelection);
                            location.reload();
                        },
                        () => {
                            purchaseSource.value = 'Mokobara Website';
                            if (orderNumberWrapper) orderNumberWrapper.classList.remove('hidden');
                            if (fetchOrderSection) fetchOrderSection.classList.remove('hidden');
                        }
                    );
                } else {
                    if (fetchOrderSection) fetchOrderSection.classList.add('hidden');
                    productTypeField.innerHTML = '<option value="" disabled selected>Select Product Type</option>';
                    productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';
                    populateProductFields();
                }
            }
        });

        const savedSelection = localStorage.getItem('selectedPurchaseSource');
        if (savedSelection) {
            purchaseSource.value = savedSelection;
            localStorage.removeItem('selectedPurchaseSource');
            purchaseSource.dispatchEvent(new Event('change'));
        }

        if (purchaseSource.value === 'Mokobara Website') {
            if (orderNumberWrapper) orderNumberWrapper.classList.remove('hidden');
            if (fetchOrderSection) fetchOrderSection.classList.remove('hidden');
        }
    }

    function showCustomPopup(onConfirm, onCancel) {
        if (!customPopup) return;
        customPopup.classList.remove('hidden');
        customPopup.classList.add('flex');

        if (popupOk) {
            popupOk.onclick = function () {
                customPopup.classList.add('hidden');
                customPopup.classList.remove('flex');
                onConfirm();
            };
        }

        if (popupCancel) {
            popupCancel.onclick = function () {
                customPopup.classList.add('hidden');
                customPopup.classList.remove('flex');
                onCancel();
            };
        }
    }

    function lockBodyScroll() {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.classList.add('overflow-hidden');
        document.body.dataset.scrollY = scrollY;
    }

    function unlockBodyScroll() {
        const scrollY = document.body.dataset.scrollY || '0';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.classList.remove('overflow-hidden');
        window.scrollTo(0, parseInt(scrollY, 10));
        delete document.body.dataset.scrollY;
    }

    function setupEventListeners() {
        setupInputValidation();
        setupInputRestrictions();
        handlePurchaseSourceChange();
        handleVideoUpload();
        handleImageUpload();
        setupPurchaseDate();

        if (productTypeField) {
            productTypeField.addEventListener('change', function () {
                skuField.value = '';
                productColorField.value = '';
                variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
                updateProductNames();
            });
        }

        if (productNameField) {
            productNameField.addEventListener('change', function () {
                updateVariantDetails();
            });
        }

        if (variantNameField) {
            variantNameField.addEventListener('change', function () {
                const selectedType = productTypeField.value;
                const selectedName = productNameField.value;
                const selectedVariant = variantNameField.value;

                if (!selectedType || !selectedName || !selectedVariant) {
                    skuField.value = '';
                    productColorField.value = '';
                    return;
                }

                // Auto-populate product-size from variant title (matches live)
                const productSizeField = document.getElementById('product-size');
                if (productSizeField) {
                    const variantLower = selectedVariant.toLowerCase();
                    if (variantLower.includes('cabin') || variantLower.includes('small')) {
                        productSizeField.value = 'Small (Cabin)';
                    } else if (variantLower.includes('check-in large') || variantLower.includes('large')) {
                        productSizeField.value = 'Large (Check-in Large)';
                    } else if (variantLower.includes('check-in') || variantLower.includes('medium')) {
                        productSizeField.value = 'Medium (Check-in)';
                    }
                }

                const encodedType = encodeURIComponent(selectedType);
                const encodedName = encodeURIComponent(selectedName);
                const encodedVariant = encodeURIComponent(selectedVariant);

                fetch(`https://themokolabs.com/api/customer/warranty/get-product-sku?type=${encodedType}&name=${encodedName}&variant=${encodedVariant}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.sku || data.color) {
                            skuField.value = data.sku || '';
                            productColorField.value = data.color || '';
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching SKU and color:', error);
                    });
            });
        }

        if (fetchOrderBtn) {
            fetchOrderBtn.addEventListener('click', function (e) {
                e.preventDefault();
                fetchOrderDetails();
            });
        }

        submitButtons.forEach(btn => {
            btn.addEventListener('click', handleFormSubmission);
        });

        backButtons.forEach(btn => {
            btn.addEventListener('click', goToPreviousStep);
        });

        if (overlayCloseBtn) {
            overlayCloseBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                closeOverlay();
            });
        }

        if (overlay) {
            overlay.addEventListener('click', function (e) {
                if (e.target === overlay) {
                    closeOverlay();
                }
            });
        }

        if (overlayContent) {
            overlayContent.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        }
    }
});

